module.exports = __webpack_public_path__ + "img/no-disponible.d949d6e1.svg";